import ButtonAnchor from "./basic/ButtonAnchor";

const LucyMod = () => {
  return (
    <main>

      <section className="articles">

        <article className="left-image">

          <img src="/images/mod_blocks.png" className="pixel-art" alt="Lucy's Mod Blocks" />
          <div>

            <h3>Lucy's Mod</h3>
            <p>
              Lucy's Mod is the mod I made for Minecraft 1.20.2, using Fabric. It adds a new purple wood type, a new stone block called Pearlstone, new ores, Chromium and Bonzite and new decorative blocks the Big Making Table and the Toolstation. There are also new tools and armour pieces made from Chromium, each of which can be upgraded using Pearls to boost their stats, and new tools and armour pieces made from Bonzite, which can be crafted by upgrading the final form of their Chromium equivalent using a Bonzite Upgrade smithing template.
              <br /><br />
              It isn't completely perfect, but below you can download the first public version, which should work well for Creative Mode, and I plan on making a guide for Survival Mode, giving hints about where new things can be found and new crafting recipes. I also might upload this to CurseForge in the future, but this isn't a priority at the moment.
            </p>
            <ButtonAnchor to="/lucymod-0.1-1.20.2.zip" text="Download the Mod" icon_path="/images/icons/mod-icon.svg" alt_text="Cube" />
          
          </div>
          
        </article>
      
      </section>

    </main>
  );
}

export default LucyMod;